module.exports = __webpack_public_path__ + "img/2.d70014db.jpeg";